type SubscribeResult =
  | { ok: true }
  | { ok: false; error: "invalid-email" | "rate-limited" | "unknown" };

export async function subscribeToNewsletter(
  email: string,
  locale: string,
): Promise<SubscribeResult> {
  const res = await fetch("/api/newsletter/subscribe", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, locale }),
  });
  if (res.status === 429) {
    return { ok: false, error: "rate-limited" };
  }
  if (!res.ok) {
    const data = await res.json().catch(() => null);
    if (data?.error === "invalid-email") {
      return { ok: false, error: "invalid-email" };
    }
    return { ok: false, error: "unknown" };
  }
  return { ok: true };
}

export type NewsletterStatus = "confirmed" | "pending" | "unsubscribed" | "not-subscribed";

export async function getNewsletterStatus(): Promise<NewsletterStatus> {
  const res = await fetch("/api/me/newsletter");
  if (!res.ok) throw new Error("Failed to fetch newsletter status");
  const data = await res.json() as { status: NewsletterStatus };
  return data.status;
}

export async function setNewsletterSubscription(subscribed: boolean): Promise<NewsletterStatus> {
  const res = await fetch("/api/me/newsletter", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ subscribed }),
  });
  if (!res.ok) throw new Error("Failed to update newsletter subscription");
  const data = await res.json() as { status: NewsletterStatus };
  return data.status;
}
